/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  checkStoreData,
  getStoreData,
  initStoreData,
  updateStoreData,
} from 'src/storage';
import {
  priorityExecuteLastSessionData,
  priorityProcessQueue,
  priorityExecuteLocalStorage,
} from './priorityQueue';
import {
  batchedProcessQueue,
  batchedExecuteLocalStorage,
  batchedExecuteLastSessionData,
} from './batchQueue';

// without Store LocalStorage Queue execution
import {
  withOutLocalStorePriorityProcessQueue,
  withOutLocalStorePriorityExecuteLocalStorage,
} from './priorityWithoutLocalStorageQueue';
import {
  withOutLocalStoreBatchedProcessQueue,
  withOutLocalStoreBatchedExecuteLocalStorage,
} from './batchWithoutLocalStorageQueue';
import {
  GODAVARI_EVENT_TYPE,
  SESSION_KEY_STORAGE_TYPE,
  SESSION_STORAGE_TYPE,
  JUST_IN_TIME_BATCH_EVENTS,
} from 'src/utils/enum';
import { getAppSessionId, getCurrentTime } from 'src/utils';
import { getSDKConfig } from 'src/utils/config';
let batchInterval;
let maxRecordLimitInterval;
let batchStoreData = [];
let batch_id = 0;
let navigatorSendBeaconStatus = false;
let priorityStoreRecordData = [];
let batchStoreRecordData = [];
const isLocalStorageEnable = typeof localStorage === 'object';

const initQueueManager = () => {
  initStorageQueue();
  window.addEventListener('online', checkNetworkOnline);
  window.addEventListener('offline', checkNetworkOffline);
  checkMaxBeaconCounter();
  batch_id = Date.now();
  startBatchedInterval();
  registerBodyUnload();
  navigatorSendBeaconStatus = typeof navigator?.sendBeacon == 'function';
};

const initStorageQueue = () => {
  const storageType = SESSION_STORAGE_TYPE;
  const storageTypeList = SESSION_KEY_STORAGE_TYPE;
  for (const key in storageTypeList) {
    if (storageTypeList[key]) {
      const sessionId = storageType[key] + getAppSessionId();
      initStoreData(storageTypeList[key], sessionId);
    }
  }
};

const checkNetworkOnline = () => {
  if (window.spnGlobalConfig.spnBeaconNetworkStatus == false) {
    window.spnGlobalConfig.spnBeaconNetworkStatus = true;
    window.spnGlobalConfig.priorityBeaconExecutionStart = false;
    window.spnGlobalConfig.batchedBeaconExecutionStart = false;
    executeCurrentSessionData();
    if (isLocalStorageEnable) {
      executeLastSessionStoreData();
    }
  }
};

const checkNetworkOffline = () => {
  if (window.spnGlobalConfig.spnBeaconNetworkStatus) {
    window.spnGlobalConfig.spnBeaconNetworkStatus = false;
    window.spnGlobalConfig.priorityBeaconExecutionStart = true;
    window.spnGlobalConfig.batchedBeaconExecutionStart = true;
  }
};

const storeNextData = (eventType, eventName, payLoadBody) => {
  if (isLocalStorageEnable) {
    // if localStorage Enable
    if (eventType == 'priority') {
      storeRecordData(eventType, eventName, payLoadBody);
    }
    storeBatchData(GODAVARI_EVENT_TYPE.BATCHED, eventName, payLoadBody);
  } else {
    // if localStorage Not Enable
    if (eventType == 'priority') {
      withoutLocalStorePriorityRecordData(eventType, eventName, payLoadBody);
    }
    withoutLocalStoreRecordBatchData(
      GODAVARI_EVENT_TYPE.BATCHED,
      eventName,
      payLoadBody
    );
  }
};

const storeRecordData = (eventType, eventName, payLoadBody) => {
  const storageType = SESSION_STORAGE_TYPE;
  const storageTypeList = SESSION_KEY_STORAGE_TYPE;
  const sessionId = storageType[eventType] + getAppSessionId();
  checkStoreData(storageTypeList[eventType], sessionId);
  let localStorageData = getStoreData(sessionId);
  const payLoadData = {
    eventType: eventType,
    eventName: eventName,
    currentTime: getCurrentTime(),
    payLoadBody: payLoadBody,
  };
  if (!Array.isArray(localStorageData)) {
    localStorageData = [];
  }
  const offlineCache = checkOfflineCache(eventType, localStorageData);
  if (offlineCache) {
    return;
  }
  localStorageData.push(payLoadData);
  updateStoreData(sessionId, localStorageData);
  startProcess(eventType);
};

const checkOfflineCache = (eventType, localStorageData) => {
  const sdkConfig = getSDKConfig();
  if (!window?.navigator?.onLine) {
    switch (eventType) {
      case 'priority':
        if (
          sdkConfig?.priority?.offline_cache_enabled &&
          localStorageData.length >= sdkConfig?.priority?.offline_cache_max_size
        ) {
          return true;
        } else if (!sdkConfig?.priority?.offline_cache_enabled) {
          return true;
        }
        break;
      case 'batched':
        if (
          sdkConfig?.batch?.offline_cache_enabled &&
          localStorageData.length >= sdkConfig?.batch?.offline_cache_max_size
        ) {
          return true;
        } else if (!sdkConfig?.batch?.offline_cache_enabled) {
          return true;
        }
        break;
    }
  }
  return false;
};

const storeBatchData = (eventType, eventName, payLoadBody = {}) => {
  const sdkConfig = getSDKConfig();
  const storageType = SESSION_STORAGE_TYPE;
  const storageTypeList = SESSION_KEY_STORAGE_TYPE;
  const sessionId = storageType[eventType] + getAppSessionId();
  checkStoreData(storageTypeList[eventType], sessionId);
  let localStorageData = getStoreData(sessionId);
  if (!Array.isArray(localStorageData)) {
    localStorageData = [];
  }
  const offlineCache = checkOfflineCache(eventType, localStorageData);
  if (offlineCache) {
    return;
  }
  let maxEventPer = sdkConfig?.batch?.queue_size;
  if (sdkConfig?.batch?.queue_size > sdkConfig?.batch?.max_events_per_beacon) {
    maxEventPer = sdkConfig?.batch?.max_events_per_beacon;
  }
  if (batchStoreData.length >= maxEventPer) {
    storeRecordData(
      GODAVARI_EVENT_TYPE.BATCHED,
      'batched_name',
      batchStoreData
    );
    batch_id = Date.now();
    batchStoreData = [];
    window.batchStoreData = batchStoreData;
  }
  if (payLoadBody && eventType === GODAVARI_EVENT_TYPE.BATCHED) {
    payLoadBody.batch_id = batch_id.toString();
  }
  batchStoreData.push(payLoadBody);
  window.batchStoreData = batchStoreData;
  // just in time execute batch event
  if (JUST_IN_TIME_BATCH_EVENTS.indexOf(eventName) !== -1) {
    storeRecordData(
      GODAVARI_EVENT_TYPE.BATCHED,
      'batched_name',
      batchStoreData
    );
    batch_id = Date.now();
    batchStoreData = [];
    window.batchStoreData = batchStoreData;
  }
};

const startBatchedInterval = () => {
  const sdkConfig = getSDKConfig();
  let batchIntervalTime = sdkConfig?.batch?.batch_interval || 300000; // Interval for batching events in seconds (5 minutes)
  if (!isLocalStorageEnable) {
    batchIntervalTime = 10000;
  }
  clearTimeout(batchInterval);
  batchInterval = setTimeout(() => {
    if (batchStoreData.length > 0) {
      if (isLocalStorageEnable) {
        storeRecordData(
          GODAVARI_EVENT_TYPE.BATCHED,
          'batched_name',
          batchStoreData
        );
      } else {
        const payLoadData = {
          eventType: GODAVARI_EVENT_TYPE.BATCHED,
          eventName: 'batched_name',
          currentTime: getCurrentTime(),
          payLoadBody: batchStoreData,
        };
        batchStoreRecordData.push(payLoadData);
        window.spnGlobalConfig.batchStoreRecordData = batchStoreRecordData;
        startProcess(GODAVARI_EVENT_TYPE.BATCHED);
      }
      batch_id = Date.now();
      batchStoreData = [];
      window.batchStoreData = batchStoreData;
    }
    startBatchedInterval();
  }, batchIntervalTime);
};

const startProcess = (eventType) => {
  if (window.spnGlobalConfig.spnBeaconNetworkStatus) {
    switch (eventType) {
      case GODAVARI_EVENT_TYPE.PRIORITY:
        if (window.spnGlobalConfig.priorityBeaconExecutionStart) {
          window.spnGlobalConfig.priorityBeaconExecutionStart = false;
          if (isLocalStorageEnable) {
            priorityProcessQueue();
          } else {
            withOutLocalStorePriorityProcessQueue();
          }
        }
        break;
      case GODAVARI_EVENT_TYPE.BATCHED:
        if (window.spnGlobalConfig.batchedBeaconExecutionStart) {
          window.spnGlobalConfig.batchedBeaconExecutionStart = false;
          if (isLocalStorageEnable) {
            batchedProcessQueue();
          } else {
            withOutLocalStoreBatchedProcessQueue();
          }
        }
        break;
    }
  }
};

// when current uuid remove from storage it will be execute first.
const executeCurrentBatchData = () => {
  const sdkConfig = getSDKConfig();
  if (batchStoreData.length == sdkConfig?.batch?.max_events_per_beacon) {
    if (isLocalStorageEnable) {
      storeRecordData(
        GODAVARI_EVENT_TYPE.BATCHED,
        'batched_name',
        batchStoreData
      );
    } else {
      const payLoadData = {
        eventType: GODAVARI_EVENT_TYPE.BATCHED,
        eventName: 'batched_name',
        currentTime: getCurrentTime(),
        payLoadBody: batchStoreData,
      };
      batchStoreRecordData.push(payLoadData);
      window.spnGlobalConfig.batchStoreRecordData = batchStoreRecordData;
      startProcess(GODAVARI_EVENT_TYPE.BATCHED);
    }
    batch_id = Date.now();
    batchStoreData = [];
    window.batchStoreData = batchStoreData;
  }
};

const executeCurrentSessionData = () => {
  if (isLocalStorageEnable) {
    priorityExecuteLocalStorage();
    batchedExecuteLocalStorage();
  } else {
    withOutLocalStorePriorityExecuteLocalStorage();
    withOutLocalStoreBatchedExecuteLocalStorage();
  }
};

const executeLastSessionStoreData = () => {
  priorityExecuteLastSessionData();
  batchedExecuteLastSessionData();
};

const checkMaxBeaconCounter = () => {
  clearInterval(maxRecordLimitInterval);
  maxRecordLimitInterval = setTimeout(() => {
    window.spnGlobalConfig.maxRecordPerMinute = 0;
    checkMaxBeaconCounter();
  }, 60000);
};

const registerBodyUnload = () => {
  window.addEventListener('beforeunload', onUnloadExecuteBatchData);
};
const onUnloadExecuteBatchData = () => {
  const sdkConfig = getSDKConfig();
  if (batchStoreData.length > 0) {
    try {
      if (navigatorSendBeaconStatus && sdkConfig?.general?.endpoints?.batched) {
        const payload = JSON.stringify(batchStoreData);
        const blob = new Blob([payload], { type: 'text/plain' }); // safer content type
        const success = navigator.sendBeacon(
          sdkConfig?.general?.endpoints?.batched,
          blob
        );
      }
    } catch (error) {
      console.log(error);
    }
    window.spnGlobalConfig.batchedBeaconExecutionStart = false;
    storeRecordData(
      GODAVARI_EVENT_TYPE.BATCHED,
      'batched_name',
      batchStoreData
    );
    batchStoreData = [];
    window.batchStoreData = batchStoreData;
    const start = Date.now();
    while (Date.now() - start < 100) {} // tiny delay to allow beacon
  } else {
    batchStoreData = [];
    window.batchStoreData = batchStoreData;
  }
};

//-------execute priority record without local Storage
const withoutLocalStorePriorityRecordData = (
  eventType,
  eventName,
  payLoadBody
) => {
  const payLoadData = {
    eventType: eventType,
    eventName: eventName,
    currentTime: getCurrentTime(),
    payLoadBody: payLoadBody,
  };
  const offlineCache = checkOfflineCache(eventType, priorityStoreRecordData);
  if (offlineCache) {
    return;
  }
  priorityStoreRecordData.push(payLoadData);
  window.spnGlobalConfig.priorityStoreRecordData = priorityStoreRecordData;
  startProcess(eventType);
};

const withoutLocalStoreRecordBatchData = (
  eventType,
  eventName,
  payLoadBody = {}
) => {
  const sdkConfig = getSDKConfig();
  const offlineCache = checkOfflineCache(eventType, batchStoreData);
  if (offlineCache) {
    return;
  }
  let maxEventPer = sdkConfig?.batch?.queue_size;
  if (sdkConfig?.batch?.queue_size > sdkConfig?.batch?.max_events_per_beacon) {
    maxEventPer = sdkConfig?.batch?.max_events_per_beacon;
  }
  if (batchStoreData.length >= maxEventPer) {
    const payLoadData = {
      eventType: GODAVARI_EVENT_TYPE.BATCHED,
      eventName: 'batched_name',
      currentTime: getCurrentTime(),
      payLoadBody: batchStoreData,
    };
    batchStoreRecordData.push(payLoadData);
    window.spnGlobalConfig.batchStoreRecordData = batchStoreRecordData;
    batch_id = Date.now();
    batchStoreData = [];
    window.batchStoreData = batchStoreData;
    startProcess(eventType);
  }
  if (payLoadBody && eventType === GODAVARI_EVENT_TYPE.BATCHED) {
    payLoadBody.batch_id = batch_id.toString();
  }
  batchStoreData.push(payLoadBody);
  window.batchStoreData = batchStoreData;
};

export {
  initStorageQueue,
  initQueueManager,
  storeNextData,
  executeLastSessionStoreData,
  checkNetworkOnline,
  checkNetworkOffline,
  executeCurrentBatchData,
  checkMaxBeaconCounter,
};
